import Axios, { AxiosRequestConfig, AxiosError } from 'axios';
import type { Problem } from 'src/generated/api/dsv-public/model';

export const CustomAxiosConfig = {
  baseUrl: 'https://termine.adventisten.cloud',
};

export const dsvApiAxiosInstance = <T>(config: AxiosRequestConfig): Promise<T> => {
  const instance = Axios.create({ baseURL: CustomAxiosConfig.baseUrl });

  instance.interceptors.response.use(
    response => response,
    (error: AxiosError<Problem>) => {
      const problemUuid = error.response?.data?.problemUuid;
      if (problemUuid) {
        console.error(`problem-uuid: ${problemUuid}`);
      }
      return Promise.reject(error);
    }
  );

  return instance.request(config).then(({ data }) => data);
};
